import React from 'react';
import { fmtDate, fmtQ } from './srUtils';

export const DeliveryHeader = ({ d }) => (
  <div className="rounded-lg border border-[#E5DFD0] bg-white p-3 grid gap-1 sm:grid-cols-2 text-sm" data-testid="sr-delivery-header">
    <div>
      <p className="text-xs text-gray-500">Supplier</p>
      <p className="font-semibold text-[#1A1F2E]" data-testid="sr-header-vendor">{d.vendor_name}</p>
      {d.vendor_address && <p className="text-xs text-gray-500">{d.vendor_address}</p>}
      {d.vendor_gst && <p className="text-xs text-gray-500">GSTIN {d.vendor_gst}</p>}
    </div>
    <div className="sm:text-right">
      <p className="font-mono font-semibold" data-testid="sr-header-doc">{d.document_barcode || d.entry_id}</p>
      {d.vendor_doc_no && <p className="text-xs text-gray-600">Invoice {d.vendor_doc_no}{d.vendor_doc_date ? ` · ${d.vendor_doc_date}` : ''}</p>}
      <p className="text-xs text-gray-500">Received {fmtDate(d.received_at)}</p>
    </div>
  </div>
);

/** The delivery's PO lines — what came above the PO and how much the typed qtys use. */
export const PoLinesSummary = ({ lines, usage }) => {
  if (!lines?.length) return null;
  return (
    <div className="rounded-lg border border-[#E5DFD0] bg-white overflow-x-auto" data-testid="sr-po-lines">
      <table className="w-full text-xs">
        <thead className="bg-[#FFFBF5] text-gray-500">
          <tr><th className="text-left p-2">PO line</th><th className="p-2">Ordered</th><th className="p-2">Received</th><th className="p-2">Above PO</th><th className="p-2">Waiting</th><th className="p-2">Returnable</th>{usage && <th className="p-2">This return</th>}</tr>
        </thead>
        <tbody>
          {lines.map((l) => {
            const used = usage?.[l.po_item_id] || 0;
            const over = used > l.available_qty + 1e-6;
            return (
              <tr key={l.po_item_id} className="border-t border-[#E5DFD0] text-center" data-testid={`sr-po-line-${l.po_item_id}`}>
                <td className="text-left p-2"><span className="font-mono">{l.po_number}</span><br /><span className="text-gray-600">{l.supplier_design_name}</span></td>
                <td className="p-2 tabular-nums">{fmtQ(l.ordered_qty)} {l.unit}</td>
                <td className="p-2 tabular-nums">{fmtQ(l.received_qty)}</td>
                <td className="p-2 tabular-nums font-semibold text-red-700">{fmtQ(l.above_po_qty)}</td>
                <td className="p-2 tabular-nums text-blue-700">{fmtQ(l.waiting_qty)}</td>
                <td className="p-2 tabular-nums font-semibold">{fmtQ(l.available_qty)}</td>
                {usage && <td className={`p-2 tabular-nums font-semibold ${over ? 'text-red-600' : 'text-[#B45309]'}`} data-testid={`sr-po-used-${l.po_item_id}`}>{fmtQ(used)}{over ? ' — too much' : ''}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
